import { render, staticRenderFns } from "./ValueCalculation.vue?vue&type=template&id=f9175d04&scoped=true"
import script from "./ValueCalculation.vue?vue&type=script&lang=js"
export * from "./ValueCalculation.vue?vue&type=script&lang=js"
import style0 from "./ValueCalculation.vue?vue&type=style&index=0&id=f9175d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9175d04",
  null
  
)

export default component.exports